var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2358 1.16406C8.80025 1.16406 1.89844 8.06587 1.89844 16.5014C1.89844 24.937 8.80025 31.8388 17.2358 31.8388C25.6713 31.8388 32.5731 24.937 32.5731 16.5014C32.5731 8.06587 25.6713 1.16406 17.2358 1.16406Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3708 13.338C23.3708 13.4339 23.3708 13.6256 23.3708 13.7214C23.3708 17.8433 20.2075 22.6363 14.456 22.6363C12.6347 22.6363 11.0051 22.157 9.66309 21.1984C9.95066 21.1984 10.1424 21.1984 10.43 21.1984C11.8678 21.1984 13.3057 20.7191 14.3602 19.8564C13.0181 19.8564 11.8678 18.8978 11.3885 17.6516C11.5803 17.6516 11.772 17.7475 11.9637 17.7475C12.2513 17.7475 12.5388 17.7475 12.8264 17.6516C11.3885 17.364 10.3341 16.1179 10.3341 14.5842C10.7175 14.7759 11.1968 14.9676 11.772 14.9676C10.9092 14.3924 10.3341 13.4339 10.3341 12.3794C10.3341 11.8043 10.5258 11.2291 10.7175 10.7498C12.2513 12.667 14.5519 13.9131 17.2359 14.009C17.14 13.8173 17.14 13.5297 17.14 13.338C17.14 11.6125 18.5779 10.1747 20.3034 10.1747C21.1661 10.1747 22.0288 10.5581 22.604 11.1332C23.275 11.0374 24.0419 10.7498 24.617 10.3664C24.4253 11.1332 23.8501 11.7084 23.275 12.0918C23.946 11.996 24.5211 11.8043 25.0963 11.6125C24.5211 12.3794 23.946 12.9546 23.3708 13.338Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTwitter);
export default __webpack_public_path__ + "static/media/footer_twitter.ed55e485480288f8a5ca37073dcb5d96.svg";
export { ForwardRef as ReactComponent };